export default __webpack_public_path__ + "static/media/general_2.96427935.png";